import { isKnownTourStepId } from "./snapTourStep";

export const DEMO_TOUR_STORAGE_VERSION = 1 as const;

const STORAGE_KEY_PREFIX = "recsys.demoTour.";

export type DemoTourProgress = {
  v: typeof DEMO_TOUR_STORAGE_VERSION;
  stepId: string;
  running: boolean;
};

export function demoTourStorageKey(username: string): string {
  return `${STORAGE_KEY_PREFIX}${username}`;
}

function isProgress(value: unknown): value is DemoTourProgress {
  if (!value || typeof value !== "object") return false;
  const obj = value as Record<string, unknown>;
  return (
    obj.v === DEMO_TOUR_STORAGE_VERSION &&
    typeof obj.stepId === "string" &&
    obj.stepId.length > 0 &&
    typeof obj.running === "boolean"
  );
}

export function readTourProgress(username: string): DemoTourProgress | null {
  if (!username) return null;
  try {
    const raw = localStorage.getItem(demoTourStorageKey(username));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (!isProgress(parsed)) return null;
    if (!isKnownTourStepId(parsed.stepId)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeTourProgress(
  username: string,
  progress: Omit<DemoTourProgress, "v">,
): void {
  if (!username) return;
  try {
    const payload: DemoTourProgress = {
      v: DEMO_TOUR_STORAGE_VERSION,
      stepId: progress.stepId,
      running: progress.running,
    };
    localStorage.setItem(demoTourStorageKey(username), JSON.stringify(payload));
  } catch {
    // localStorage unavailable — progress won't persist
  }
}

export function clearTourProgress(username: string): void {
  if (!username) return;
  try {
    localStorage.removeItem(demoTourStorageKey(username));
  } catch {
    void 0;
  }
}
